export default __webpack_public_path__ + "static/1075-11e78b71eb08d8bf045f7cb72e2a20c5.gif";